/**
 * Configurazione variabili d'ambiente per VibeTide Dashboard
 * Centralizza tutte le configurazioni da process.env
 */

// Configurazioni API
export const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'https://backend.pulse.vibetide.it/api',
  TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT) || 10000,
};

// Configurazioni WebSocket
export const WEBSOCKET_CONFIG = {
  URL: process.env.REACT_APP_WEBSOCKET_URL || 'https://backend.pulse.vibetide.it',
  RECONNECT_ATTEMPTS: parseInt(process.env.REACT_APP_WS_RECONNECT_ATTEMPTS) || 5,
  RECONNECT_DELAY: parseInt(process.env.REACT_APP_WS_RECONNECT_DELAY) || 1000,
};

// Configurazioni applicazione
export const APP_CONFIG = {
  NAME: 'VibeTide Dashboard',
  VERSION: process.env.REACT_APP_VERSION || '1.0.0',
  ENVIRONMENT: process.env.NODE_ENV || 'development',
  DEBUG: process.env.REACT_APP_DEBUG === 'true',
};

// Configurazioni UI
export const UI_CONFIG = {
  ITEMS_PER_PAGE: parseInt(process.env.REACT_APP_ITEMS_PER_PAGE) || 20,
  AUTO_REFRESH_INTERVAL: parseInt(process.env.REACT_APP_AUTO_REFRESH_INTERVAL) || 30000,
  TOAST_DURATION: parseInt(process.env.REACT_APP_TOAST_DURATION) || 4000,
};

// Validazioni configurazioni
const validateConfig = () => {
  const errors = [];

  if (!API_CONFIG.BASE_URL) {
    errors.push('REACT_APP_API_URL è obbligatorio');
  }

  if (!WEBSOCKET_CONFIG.URL) {
    errors.push('REACT_APP_WEBSOCKET_URL è obbligatorio');
  }

  if (errors.length > 0) {
    console.error('❌ Errori configurazione:', errors);
    throw new Error(`Configurazione non valida: ${errors.join(', ')}`);
  }
};

// Esegui validazione all'import
if (process.env.NODE_ENV !== 'test') {
  validateConfig();
}

// Log configurazione in sviluppo
if (APP_CONFIG.DEBUG && APP_CONFIG.ENVIRONMENT === 'development') {
  console.log('🔧 Configurazione Dashboard:', {
    API_CONFIG,
    WEBSOCKET_CONFIG,
    APP_CONFIG,
    UI_CONFIG
  });
} 
